/* eslint 'jsx-a11y/alt-text': 'off' */
import React, { Component } from "react";
import { Table, Button, Modal, Label, Form, FormGroup, Col } from "reactstrap";
import { connect } from "react-redux";
import { GetPreventativeMaintenanceList, GetWorkOrderBuildings, GetWorkOrderBuilding, SaveWorkOrderBuilding, DeleteWorkOrderBuilding, ChangeDisplayinWorkOrderBuilding } from  '../../../action/workorderAction';
import {GetBuildings} from '../../../action/Administration/administrationAction';
import SelectAllCheckboxes from '../../../Resources/SelectAllCheckboxes';
import classnames from 'classnames';
import '../../../Assets/EnsembleStyles/WorkOrders.css';
import '../../../Assets/styles/BuildingTree.css';
import ErrorGif from '../../../Assets/images/Error.gif';
//import SortableTree from 'react-sortable-tree';
import WorkOrderBuilding from './_ModalsForms/AddBuilding';
import DeleteConfirmation from '../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import { createFilter } from 'react-search-input';
import EditIcon from '../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../Assets/images/Icons__trash2.svg';
import ReactPaginate from 'react-paginate';
import LoadingIndicator from '../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['name', 'contactInformation.firstName', 'contactInformation.lastName', 'contactInformation.emailAddress', 'contactInformation.primaryPhone'];
let pagesCount = 0;
class WorkOrderBuildingList extends Component {

    componentWillMount(){
        this.props.GetWorkOrderBuildings().then(() => {this.setState({isloading:false})});
        this.props.GetBuildings();
        this.props.GetPreventativeMaintenanceList();
    }
    componentWillUnmount(){        
        this.props.ChangeDisplayinWorkOrderBuilding('BuildingList','');
    }
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            var SelectedBuilding = this.state.details;
            if(nextProps.Building_DisplayState_Response.Selected_Building_Id !== ""){
                SelectedBuilding = (this.props.getList !== undefined && this.props.getList.WorkorderBuildingDetails !== undefined) ? this.props.getList.WorkorderBuildingDetails : [];
                if(nextProps.Building_DisplayState_Response.page_to_display_building === 'ViewBuilding'){
                    var l_Children_list = this.GetChildren(SelectedBuilding.floors,SelectedBuilding.spaces);
                    let InitialData = [{ 
                        title: SelectedBuilding.name,
                        expanded: true,
                        children: l_Children_list
                    }]
                    this.setState({ treeData: InitialData });
                }
            }
            
            this.setState({
                Display: nextProps.Building_DisplayState_Response.page_to_display_building,
                details: SelectedBuilding[0] !== undefined ? SelectedBuilding[0] : SelectedBuilding
            });

            var el = document.getElementsByClassName('tab-pane active'); 
            el[0].scrollTop = 0;
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            modal: false,
            IsError: false,
            details:[],
            sort: {
                column: null,
                direction: [
                    { name: 'name', direction: 'asc', onclick: true },
                    { name: 'address', direction: 'desc', onclick: false },
                    { name: 'OpenWO', direction: 'desc', onclick: false },
                    { name: 'OpenPM', direction: 'desc', onclick: false}
                ]
            },
            Display: 'BuildingList',
            searchTerm: "",
            deletemodal: false,
            treeData: [],
            currentPage: 0,
            pageSize: 50,
            IsDefaultSort: true
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.Delete = this.Delete.bind(this);
        this.OpenDeletePopup = this.OpenDeletePopup.bind(this);
        this.EditBuilding = this.EditBuilding.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    Delete(someArg) {
        if (someArg === "yes") {
            this.props.DeleteWorkOrderBuilding(this.state.details.id,this.state.details);
            this.props.ChangeDisplayinWorkOrderBuilding('BuildingList','');
        }
        this.Deletetoggle();
    }

    OpenDeletePopup(){
        this.Deletetoggle();
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    EditBuilding(){
        this.props.ChangeDisplayinWorkOrderBuilding('EditBuilding','');
    }

    MoveToTreeConfiguration(){
        this.props.ChangeDisplayinWorkOrderBuilding('TreeView','');
    }

    MoveToWorkOrderList(){
        this.props.ChangeDisplayinWorkOrderBuilding('BuildingList','');
    }

    GetChildren(Floors,Spaces){
        let FloorInputCollection = [];
        if(Floors !== null && Floors !== undefined && Floors.length){
            for(var i=0; i<Floors.length; i++){
                var SpaceInputCollection = [];
                if(Floors.spaces !== null && Floors[i].spaces.length){
                    for(var j=0; j<Floors[i].spaces.length; j++){
                        SpaceInputCollection[j] = {title: Floors[i].spaces[j].name};
                    }
                }
                FloorInputCollection[i] = {title: Floors[i].name, expanded: true, children: SpaceInputCollection };
            }
        }
        if(Spaces !== undefined && Spaces !== null && Spaces.length){
            var StartPt = FloorInputCollection.length;
            /*eslint-disable*/
            var j=0; 
            for(var i=StartPt; i<(Number(StartPt)+Number(Spaces.length)); i++){
                FloorInputCollection[i] = {title: Spaces[j].name};
                j++;
            }
        }
        return FloorInputCollection;
    }

    /* Pagination System */
    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    };

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.building_search_value.value })
    }

    OpenAddNewBuilding() {
        this.props.ChangeDisplayinWorkOrderBuilding('AddBuilding','');
    }

    OpenPopup(){
        this.setState({modal: !this.state.modal, IsError: false});
    }

    SaveImportedBuildings(Rows){
      this.setState({IsError:false});
      var ImportBuildingList=[];
      let BuildingData = this.props.Buildinglist;
      for (var i = 0; i < Rows.length; i++) {
          var id = Rows[i].props.children[0].props.children.ref;
          if(this.refs[id].checked){
          let data = BuildingData.filter(el=>el.id == id);
            var Data = {
                "Name": data[0].name,
                "Address": {
                     "StreetAddress1": data[0].address1,
                     "StateOrProvince": data[0].addressState,
                     "City": data[0].addressCity,
                     "PostalCode": data[0].postalCode
                },
                "ContactInformation":{
                    "FirstName": "",
                    "LastName": "",
                    "EmailAddress": data[0].emailAddress,
                    "PrimaryPhone": data[0].phoneNumber,
                    "SecondaryPhone": ""
                },
                "SiteId": data[0].id,
                "TimeZone": data[0].timeZone,
                "IsDaylightSavingTimeEnabled": data[0].isDaylightSavingTimeEnabled
            }
           ImportBuildingList.push(Data);
         }
        }
        if( ImportBuildingList != null &&  ImportBuildingList != undefined && ImportBuildingList.length > 0){
            const actionResponse = this.props.SaveWorkOrderBuilding(ImportBuildingList);
                    actionResponse.then((result) => {
                        this.props.GetWorkOrderBuildings();
                    })
            this.setState({modal:false});
         }
         else{
            this.setState({IsError:true});
         }
        
    }

    ViewBuildingDetails(detail){
        const action_Response = this.props.GetWorkOrderBuilding(detail.id);
        action_Response.then((res) => {
            this.setState({ details: detail });
            this.props.ChangeDisplayinWorkOrderBuilding('ViewBuilding',detail.id);
        })
    }

    /* Sorting  System */
    onSortNumber = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getList.WorkorderBuildings;
        var workorder_from_state = this.props.getWorkOrderList.WorkOrderList;
        var pm_from_state = this.props.getWorkOrderList.PreventativeMaintenanceList;
        if (data_from_state != null) {
            var sortedData = [];
            if (column === "OpenWO") {
                sortedData = data_from_state.sort((a, b) => {
                    var OpenWO1 = [], OpenWO2 = [];
                    if (workorder_from_state !== undefined && workorder_from_state !== null && workorder_from_state.length > 0) {
                        OpenWO1 = workorder_from_state.filter(ele => ele.workOrderDetail.siteID == a["id"])
                        OpenWO2 = workorder_from_state.filter(ele => ele.workOrderDetail.siteID == b["id"])
                    }
                    return (OpenWO1.length - OpenWO2.length);
                });
            }
            else if(column === "OpenPM"){
                sortedData = data_from_state.sort((a, b) => {
                    var OpenPM1 = [], OpenPM2 = [];
                    if (pm_from_state !== undefined && pm_from_state !== null && pm_from_state.length > 0) {
                        OpenPM1 = pm_from_state.filter(ele => ele.buildingId == a["id"])
                        OpenPM2 = pm_from_state.filter(ele => ele.buildingId == b["id"])
                    }
                    return (OpenPM1.length - OpenPM2.length);
                });
            } else {
                sortedData = data_from_state.sort((a, b) => {
                    let nameA = a[column];
                    let nameB = b[column];
                    return (nameA - nameB);
                });
            }
            if (direction === 'desc') {
                sortedData.reverse();
            }
            if (selected[0].name == "OpenWO") {
                SortData[2].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "OpenWO") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "OpenPM") {
                SortData[3].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "OpenPM") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            this.props.getList.WorkorderBuildings = sortedData;
            this.setState({
                sort: { column, direction: SortData }
            });
        }
    };

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getList.WorkorderBuildings;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData = this.props.getList.WorkorderBuildings.sort((a, b) => {
                let nameA = a[column].toLowerCase();
                let nameB = b[column].toLowerCase();

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }

            if (selected[0].name == "name") {
                SortData[0].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "name") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "address") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "address") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            this.props.getList.WorkorderBuildings = sortedData;
            this.setState({
                sort: { column, direction : SortData }
            });
        }
    };
    
    render(getLabels,getList,getWorkOrderList,Buildinglist) {
        let import_buildings,building_data = null,Error_Msg,Buildings;
        let WorkorderBuildings, active_content = null;
        let lBuildinglength = 0, lCurrentBuildinglength = 0;
        let label = this.props.getLabels;
        let adminLabel = this.props.getAdminLabels;
        let data = this.props.Buildinglist;
        if(this.props.getList !== undefined && this.props.getList !== null && this.props.getList.WorkorderBuildings !== undefined && this.props.getList.WorkorderBuildings !== null && this.props.getList.WorkorderBuildings.length){
            Buildings = this.props.getList.WorkorderBuildings.filter(el => el.isDeleted == 0);
        }
        if (data != undefined && data!= null && data.length > 0) {
            if(Buildings != undefined && Buildings != null && Buildings.length >0){
              Buildings.forEach(function(item){
                   data = data.filter(el => el.name != item.name);
              })
            }
            if(data.length > 0){
                building_data = data.map(el => {
                    return <tr key={el.id}>
                        <td><input type="checkbox" ref={el.id} className="ImportBuilding_rows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("ImportBuilding_rows", "ImportBuilding_header_Check_box"); }} value={el.id} /></td>
                        <td>{el.name}</td>
                        <td>
                            {(el.addressCity != "") ? el.addressCity : ""}
                            {(el.addressCountry != "" && el.addressCity != "") ? ((', ') + el.addressCountry) : (el.addressCountry != "") ? el.addressCountry : ""}
                            {(el.addressCountry != "" && el.addressState != "") ? ((', ') + el.addressState) : (el.addressState != "") ? el.addressState : ""}
                        </td>
                    </tr>
                });
            }else{
                building_data = <tr><td colSpan="3">No Records Found</td></tr>
            }
        }else{
            building_data = <tr><td colSpan="3">No Records Found</td></tr>
        }

        let WorkOrder_Data = this.props.getWorkOrderList.WorkOrderList;
        let PM_Data = this.props.getWorkOrderList.PreventativeMaintenanceList;
        if (Buildings != undefined && Buildings!= null && Buildings.length > 0 && !this.state.isloading) {
            if(this.state.IsDefaultSort){
                //eslint-disable-next-line
                let sortedData = Buildings.sort((a, b) => {
                    let nameA = a['name'].toLowerCase();
                    let nameB = b['name'].toLowerCase();
    
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                });
            }
            let FilteredData = Buildings.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lBuildinglength = FilteredData.length;
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            WorkorderBuildings = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
            ).map(el => {
                var OpenWO = [], OpenPM = [];
                if (WorkOrder_Data !== undefined && WorkOrder_Data !== null && WorkOrder_Data.length > 0) {
                    OpenWO = WorkOrder_Data.filter(ele => ele.workOrderDetail.siteID == el.id)
                }
                if(PM_Data !== undefined && PM_Data !== null && PM_Data.length > 0){
                    OpenPM = PM_Data.filter(ele => ele.buildingId == el.id);
                }
                return <tr key={el.id}>
                    <td width="30%" className="link_cursorUnderline" onClick={()=>{this.ViewBuildingDetails(el)}}>{el.name}</td>
                    <td width="40%">
                                    {(el.contactInformation.firstName !== "" || el.contactInformation.lastName !== "")? ((el.contactInformation.firstName)+(' ')+(el.contactInformation.lastName)): ""}
                                    {(el.contactInformation.firstName !== "" || el.contactInformation.lastName !== "") && (el.contactInformation.emailAddress !== "" ) ? ', ' : "" }
                                    {(el.contactInformation.emailAddress !== "") ? (el.contactInformation.emailAddress):""}
                                    {((el.contactInformation.firstName !== "" || el.contactInformation.lastName !== "") || el.contactInformation.emailAddress !== "") && (el.contactInformation.primaryPhone !== "") ? ', ' : "" }
                                    {(el.contactInformation.primaryPhone !== "") ? (el.contactInformation.primaryPhone):""}
                    </td>
                    <td width="15%">{OpenWO.length}</td>    
                    <td width="15%">{OpenPM.length}</td>              
                </tr>
            }) : <tr><td colSpan="5">{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr> ;
            if(WorkorderBuildings.length !== undefined)
                lCurrentBuildinglength = WorkorderBuildings.length;
        } else if(!this.state.isloading) {
            WorkorderBuildings = <tr><td colSpan="5">{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
        } else {
            WorkorderBuildings = <tr><td colSpan="5" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }

        if (this.state.Display == 'BuildingList') {
            active_content = <div className="main_container" style={{'padding-top':'0px'}}> 
                    <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                        <div className="col-md-12">
                            <label className="child_tab_paginationtext">{(lBuildinglength !== 0 ? this.state.currentPage * 50 + 1 : 0) + "-" + ((this.state.currentPage * 50) + lCurrentBuildinglength) + " of " + lBuildinglength + " records"}</label>
                            <Button className="child_tab_button" style={{ 'width': '135px', 'margin-left': '8px' }} onClick={() => { this.OpenAddNewBuilding() }}>{label['Building.AddNewBuilding.Text'] !== undefined ? label['Building.AddNewBuilding.Text'] : "ADD NEW BUILDING"}</Button>
                            <Button className="child_tab_button" style={{ 'width': '133px' }} onClick={() => { this.OpenPopup() }}>{label['Building.ImportBuilding.Text'] !== undefined ? label['Building.ImportBuilding.Text'] : "IMPORT BUILDINGS"}</Button>
                            <span className="pm_outersearchbox" style={{ float: 'right' }}>
                                <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='building_search_value' />
                            </span>
                            <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                        </div>
                    </div>
                    <br/>
                    <div className="table_container table_border" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
                        <Table striped responsive className="Custom_table">
                            <tbody  className="cell_container">
                                <tr>
                                    <th className="wo_cursor" onClick={this.onSort('name')}>
                                        {label['WorkOrders.Buildings.Name.Text'] !== undefined ? label['WorkOrders.Buildings.Name.Text'] : "NAME"}
                                        <span className={(this.state.sort.direction[0].name == "name") ?
                                            (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th className="wo_cursor">
                                        {label['WorkOrders.Buildings.MainContact.Text'] !== undefined ? label['WorkOrders.Buildings.MainContact.Text'] : "MAIN CONTACT"}
                                    </th>
                                    <th className="wo_cursor" onClick={this.onSortNumber('OpenWO')}>
                                        {label['WorkOrders.Buildings.WorkOrders.Text'] !== undefined ? label['WorkOrders.Buildings.WorkOrders.Text'] : "WORK ORDERS"}
                                        <span className={(this.state.sort.direction[2] !== undefined && this.state.sort.direction[2].name == "OpenWO") ?
                                            (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>
                                    <th className="wo_cursor" onClick={this.onSortNumber('OpenPM')}>
                                        {label['WorkOrders.Buildings.PMs.Text'] !== undefined ? label['WorkOrders.Buildings.PMs.Text'] : "PMs"}
                                        <span className={(this.state.sort.direction[3] !== undefined && this.state.sort.direction[3].name == "OpenPM") ?
                                            (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                    </th>                              
                                </tr>
                                {WorkorderBuildings}
                            </tbody>                       
                        </Table>
                    </div>
                    <div className="row row_padding pm_pagination" style={{'margin-right':'15px'}}>
                    <div className="col-md-7">
                        <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me pagination_margin'}
                        breakLinkClassName={'pagination_link_color'}
                        pageCount={pagesCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination pagination_container_margin'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        disabledClassName={'pagination_disable_link'}
                        pageClassName={'pagination_margin'}
                        pageLinkClassName={'pagination_link_color'}
                        previousClassName={'pagination_margin'}
                        previousLinkClassName={'pagination_link_color'}
                        nextClassName={'pagination_margin'}
                        nextLinkClassName={'pagination_link_color'}
                        forcePage={this.state.currentPage}
                        />
                    </div>
                </div>
            </div>
        }
        else if(this.state.Display == 'AddBuilding'){
            active_content =  <WorkOrderBuilding/>
        }
        else if(this.state.Display == 'EditBuilding'){
            active_content = <WorkOrderBuilding EditBuildingDetails={this.state.details} IsEdit={true}/>
        }
        else if(this.state.Display == 'ViewBuilding'){
            active_content = <div className="main_container"> 
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <button className="btn btn-black" style={{color:'white'}} onClick={() => { this.MoveToWorkOrderList() }} > {"< BACK"} </button>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <img src={DeleteIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', valign: 'bottom', 'margin-top': '1px',width:'15px',height:'14px'}} onClick={this.OpenDeletePopup}/>
                            <img src={EditIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor"  style={{ color: '#676767', 'margin-top': '1px',width:'15px',height:'14px' }} onClick={this.EditBuilding}/>
                        </Col>
                    </FormGroup>
                    <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workordermainheaderlbl'>Building Details</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className='workordermainheaderlbl'>Main Contact</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>Name</Label><br />
                            <Label className="workorderlbl">{this.state.details.name}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className='workorderheaderlbl'>First Name</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className='workorderheaderlbl'>Last Name</Label></td>
                                </tr>
                                <tr>
                                    <td><Label className="workorderlbl">{this.state.details.contactInformation != undefined ? this.state.details.contactInformation.firstName : ""}</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className="workorderlbl">{this.state.details.contactInformation != undefined ? this.state.details.contactInformation.lastName : ""}</Label></td>
                                </tr>
                            </table>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>Street Address</Label><br />
                            <Label className="workorderlbl">{this.state.details.address != undefined ? this.state.details.address.streetAddress1 : ""}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>Email Address</Label><br />
                            <Label className="workorderlbl">{this.state.details.contactInformation != undefined ? this.state.details.contactInformation.emailAddress : ""}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className='workorderheaderlbl'>City</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className='workorderheaderlbl'>State</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className='workorderheaderlbl'>Zip</Label></td>
                                </tr>
                                <tr>
                                    <td><Label className="workorderlbl">{this.state.details.address != undefined ? this.state.details.address.city : ""}</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className="workorderlbl">{this.state.details.address != undefined ? this.state.details.address.stateOrProvince : ""}</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className="workorderlbl">{this.state.details.address != undefined ? this.state.details.address.postalCode : ""}</Label></td>
                                </tr>
                            </table>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className='workorderheaderlbl'>Primary Phone</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className='workorderheaderlbl'>Secondary Phone</Label></td>
                                </tr>
                                <tr>
                                    <td><Label className="workorderlbl">{this.state.details.contactInformation != undefined ? this.state.details.contactInformation.primaryPhone : ""}</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className="workorderlbl">{this.state.details.contactInformation != undefined ? this.state.details.contactInformation.secondaryPhone : ""}</Label></td>
                                </tr>
                            </table>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className='workorderheaderlbl'>Time Zone</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className='workorderheaderlbl'>Adjust for Daylight Savings Time</Label></td>
                                </tr>
                                <tr>
                                    <td><Label className="workorderlbl">{'[' + adminLabel['EnumGMT.' + this.state.details.timeZone + '.Text'] + '] - ' + adminLabel['EnumGMTLong.' + this.state.details.timeZone + '.Text']}</Label></td>
                                    <td style={{"padding-left":"25px"}}><Label className="workorderlbl">{this.state.details.isDaylightSavingTimeEnabled ? "Yes" : "No"}</Label></td>
                                </tr>
                            </table>
                        </Col>
                    </FormGroup> 
                    <br/>                        
                    {/* <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <button className="wo_employeebtn-black" onClick={() => { this.MoveToTreeConfiguration() }} >CONFIGURE</button>
                        </Col>
                    </FormGroup> */}
                    {/* <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <div style={{"height":"100%"}}>
                                <SortableTree
                                    treeData={this.state.treeData}
                                    onChange={treeData => this.setState({ treeData })}
                                    canDrag={false}
                                    canDrop={false}
                                    expanded={true}
                                    isVirtualized={false}
                                />
                            </div>
                        </Col>
                    </FormGroup> */}
                    </Form>
                    <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={"ModalContainer short_modal"} >
                        <DeleteConfirmation parentToChildData={["Delete Work Order Building", "You are about to delete a work order building from the system. Do you want to continue?", "Close Window", "Delete Building"]} Delete={this.Delete} />
                    </Modal>
            </div>
        }  

        if(this.state.IsError){
            Error_Msg = <p  className="error_msg" style={{"margin-left":"14px"}}>
            <img src={ErrorGif} alt="Trane Logo" /> "At least one checkbox must be checked!" </p>
        }
        import_buildings = <div>{Error_Msg}
            <legend className="form_sub_title" style={{"margin-left":"14px"}}>Ensemble Building List</legend>
            <div className="table_container table_border">
                <Table striped responsive className="Custom_table">
                    <tbody className="cell_container">
                        <tr>
                            <th><input type="checkbox" className="ImportBuilding_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("ImportBuilding_rows", "ImportBuilding_header_Check_box"); }} /></th>
                            <th>BUILDING</th>
                            <th>ADDRESS</th>
                        </tr>
                        {building_data}
                    </tbody>
                </Table>
            </div>
            <FormGroup row className="btns_group">
                <Col sm={{ size: 10 }}>
                    <Button className="btn-gray btn-md" style={{"margin-left":"14px"}} onClick={() => { this.OpenPopup() }}> Cancel </Button>
                    <Button className="btn btn-success" onClick={() => { this.SaveImportedBuildings(building_data) }}>Import</Button>
                </Col>
            </FormGroup>
        </div>
        return (
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
            <div className="border_container">&nbsp;
            {active_content}
            <Modal isOpen={this.state.modal} className={classnames({ classnames: this.props.className }, "ModalContainer")}>
                {import_buildings}
            </Modal>
            </div>
            </div>
        );

    }
};

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderList: state.WorkorderRootReducer,
        getList: state.WorkorderRootReducer,
        Building_DisplayState_Response: state.WorkorderRootReducer.WorkOrderBuildingDisplay,
        Buildinglist: state.InstallationsRootReducer.BuildingList,
        getWorkOrderBuildingList: state.WorkorderRootReducer,
        getAdminLabels: state.CommonResourceDataRootReducer.CommonResourcesData
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceList: () => dispatch(GetPreventativeMaintenanceList()),
        SaveWorkOrderBuilding: (data) => dispatch(SaveWorkOrderBuilding(data)),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuilding: (id) => dispatch(GetWorkOrderBuilding(id)),
        GetBuildings:() => dispatch(GetBuildings()),
        ChangeDisplayinWorkOrderBuilding: (data,building) => dispatch(ChangeDisplayinWorkOrderBuilding(data,building)),
        DeleteWorkOrderBuilding: (id,data) => dispatch(DeleteWorkOrderBuilding(id,data)),
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(WorkOrderBuildingList);
